import { Operation } from '../../../__generated__/globalTypes'

import deleteContactShareString from '../DeleteContactShare.graphql'

export type DeleteContactShareData = {
  deleteContactShare: {
    deleted: boolean
  }
}

export type DeleteContactShareVariables = {
  id: string
}

export type DeleteContactShare = Operation<
  DeleteContactShareData,
  DeleteContactShareVariables
>

export const DeleteContactShare = ({
  id,
}: DeleteContactShareVariables): DeleteContactShare => ({
  query: deleteContactShareString,
  variables: {
    id,
  },
})
